import { useParams } from 'react-router-dom';
import slugify from 'slugify';

import { useStarlinkContent } from 'hooks';

import type { ContentBuilderProps, GenericContentStarlinkType } from 'domains/content.d';
import type { Component, StarlinkResponse } from 'domains/starlink.d';

export const useContentBuilder = () => {
  const { title: paramContent = '' } = useParams();
  const title = decodeURIComponent(paramContent);
  const {
    data: starlinkData,
    isLoading,
    ...rest
  } = useStarlinkContent<GenericContentStarlinkType>({
    document: 'content_builder',
  });
  const starlinkContent = starlinkData?.items as StarlinkResponse<Component, ContentBuilderProps>[];
  const content =
    starlinkContent &&
    starlinkContent.find(
      (item) =>
        slugify((item.data.title as string) ?? '', { lower: true }) ===
        slugify(title, { lower: true })
    );
  const contentData = content?.data as ContentBuilderProps | undefined;
  const shouldShowContent =
    content &&
    ['portal', 'todos'].some((visibilityType) => contentData?.visibility === visibilityType);

  return {
    data: {
      options: contentData,
      components: content?.components,
    },
    shouldShowContent,
    isLoading,
    path: title,
    ...rest,
  };
};
